export enum SailingStatusType {
  Normal = 'normal',
  Delayed = 'delayed',
  Cancelled = 'cancelled',
  }
